import React from "react";
import GitHubCorners from "@uiw/react-github-corners";

function GitHubLink() {
  return (
    <GitHubCorners
      position="right"
      fixed={true}
      color="#e5e5e5"
      href="https://github.com/magabiev/acr"
    />
  );
}

export default GitHubLink;
